import { render, staticRenderFns } from "./BtmBtn.vue?vue&type=template&id=e6dd8952"
import script from "./BtmBtn.vue?vue&type=script&lang=js"
export * from "./BtmBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports